import { type FunctionalComponent, h, type VNode } from '@stencil/core';
import { GuidedGenericQuickLink } from '../../models/quick-link';
import imagePlaceholderGS from '../../../../assets/svg/image_placeholder_gs.svg';
import type { GuidedV2Emitters } from '../../models/eventNames';
import type { labelProviderInterface } from '../../../LabelProviderInterface';
import {GuidedV2LinkAttributeRender} from '../link-attribute-render/link-attribute-render';
import {GuidedV2LinkTagRender} from '../link-tag-render/link-tag-renderer';

export interface GuidedVideoTutorialsQuickLinkProps
  extends GuidedGenericQuickLink {
  eventEmitters?: GuidedV2Emitters;
  labelProvider?: labelProviderInterface;
}

export const quickLinkVideoTutorials: () => FunctionalComponent<GuidedVideoTutorialsQuickLinkProps> =
  () => {
      return (props) => {
          const {
            quickLinkDescription,
            quickLinkCategory,
            quickLinkTitle,
            quickLinkOpenUrl,
            eventEmitters,
            quickLinkBadges,
            quickLinkImage,
          } = props;

          const emitters = eventEmitters() ?? undefined;

          const clickEmitter = (ev: MouseEvent) => {
              const clickEvent = emitters?.completed?.emit({
                link: quickLinkOpenUrl,
                event: 'guidedSearchClick',
                category: quickLinkCategory,
              });

              if (clickEvent.defaultPrevented) {
                ev.preventDefault();
              }
          };

          return (
        <li class="guided-v2-result-list-section__result add-selector-strength">
          <a
            class="guided-v2-result-list-section__result-link add-selector-strength video-tutorials"
            href={quickLinkOpenUrl}
            onClick={clickEmitter}
            target="_blank"
          >
            <uiaas-guided-v2-link-image src={quickLinkImage} alt={quickLinkTitle} />
            <div>
              <div class="guided-v2-result-list-section__result-title add-selector-strength">
                {quickLinkTitle}
                {quickLinkDescription && <span>- {quickLinkDescription}</span>}
              </div>
              <div class="guided-v2-result-list-section__result-extra add-selector-strength">
                {quickLinkBadges.attributes.map((attribute) => (
                  <GuidedV2LinkAttributeRender
                    attribute={attribute}
                  ></GuidedV2LinkAttributeRender>
                ))}

                {quickLinkBadges.tags.map((tag) => (
                  <GuidedV2LinkTagRender tag={tag}></GuidedV2LinkTagRender>
                ))}
              </div>
            </div>
          </a>
        </li>
      ) as VNode;
      };
  };
